// extracted by mini-css-extract-plugin
export default {"placeholder":"Placeholder--placeholder--JSyfU","shimmer":"Placeholder--shimmer--1ib-T"};